import React from 'react';
import '../styles/Dashboard.css';

const ModalAlert = ({ 
  type, 
  isOpen, 
  title, 
  message, 
  warningText,
  additionalText,
  onClose, 
  onConfirm, 
  confirmText,
  cancelText,
  confirmButtonClass,
  hideFooter,
  children
}) => {
  if (!isOpen) return null;

  // Define modalSize baseado no tipo
  let modalSize = "";
  if (type === "large") {
    modalSize = "large-modal";
  } else if (type === "confirm") {
    modalSize = "confirm-modal";
  }

  return (
    <div className="modal-overlay">
      <div className={`modal-container ${modalSize}`}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          {message && <p>{message}</p>}
          {warningText && <p className="warning-text">{warningText}</p>}
          {additionalText && <p className="warning-text">{additionalText}</p>}
          {children}
        </div>
        {!hideFooter && (
          <div className="modal-footer">
            <button className="cancel-button" onClick={onClose}>
              {cancelText || "Cancelar"}
            </button>
            {onConfirm && (
              <button 
                className={confirmButtonClass || "create-button"} 
                onClick={onConfirm}
              >
                {confirmText || "Confirmar"}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

// Componentes especializados para tipos específicos de modais
export const ConfirmDeleteModal = ({ 
  isOpen, 
  itemName, 
  itemType = "item", 
  additionalWarning,
  onClose, 
  onConfirm 
}) => {
  return (
    <ModalAlert
      type="confirm"
      isOpen={isOpen}
      title="Confirmar Exclusão"
      message={`Tem certeza que deseja excluir o ${itemType} "${itemName}"?`}
      warningText="Esta ação não pode ser desfeita!"
      additionalText={additionalWarning}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText="Excluir"
      confirmButtonClass="delete-button"
    />
  );
};

export const ConfirmLogoutModal = ({ 
  isOpen, 
  onClose, 
  onConfirm 
}) => {
  return (
    <ModalAlert
      type="confirm"
      isOpen={isOpen}
      title="Confirmar Saída"
      message="Você tem alterações não salvas. Deseja realmente sair?"
      warningText="As alterações não salvas serão perdidas!"
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText="Sair"
      confirmButtonClass="create-button"
    />
  );
};

export const FormModal = ({ 
  isOpen, 
  title, 
  onClose, 
  onConfirm, 
  confirmText,
  hideFooter,
  children
}) => {
  return (
    <ModalAlert
      type="large"
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText={confirmText}
      hideFooter={hideFooter}
    >
      {children}
    </ModalAlert>
  );
};

export default ModalAlert; 